import { render } from "./Servis.vue?vue&type=template&id=ac689f4c&scoped=true"
import script from "./Servis.vue?vue&type=script&lang=js"
export * from "./Servis.vue?vue&type=script&lang=js"

import "./Servis.vue?vue&type=style&index=0&id=ac689f4c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Евадент\\eva\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac689f4c"]])

export default __exports__